export default __webpack_public_path__ + "static/media/qr_order.a15fe81b.png";